// extracted by mini-css-extract-plugin
export default {"UserForm":"UserForm_UserForm__z+DTx","UserFormButtons":"UserForm_UserFormButtons__sbijF"};